import { Injectable } from "@angular/core";
import { EmployeeService } from "app/api/services";
import { Roles } from "../../../shared/models/roles.model";
import { EmployeeResponse, EmployeeResponseDlmBaseResponse } from "app/api/models";
import { LocalStoreService } from "app/core/services/local-store.service";

@Injectable({
  providedIn: "root",
})
export class UserRoleService {
  private currentUserRole = "";
  static EVERYONE_ACCESS = ["1", "2", "3", "4", "5"];
  static ADMIN_AND_ENGINEER_ACCESS = ["1", "2"];
  static ADMIN_AND_COORDINATOR_ACCESS = ["2", "3"];
  static ENGINEER_AND_COORDINATOR_ACCESS = ["1", "3"];
  static ONLY_ENGINEER_ACCESS = ["1"];
  static ONLY_ADMIN_ACCESS = ["2"];
  static ONLY_COORDINATOR_ACCESS = ["3"];
  static ONLY_SUPERADMIN_ACCESS = ["4"]; // should get everything
  static ONLY_ELEVATEDADMIN_ACCESS = ["5"]; // everything plus elevated software employee-only areas

  private APP_USER = "NEXUS_USER";
  private APP_ROLE = "NEXUS_ROLE";

  constructor(
    private employeeService: EmployeeService,
    public localStoreService: LocalStoreService,
  ) {}

  getCurrentUserRole() {
    if (this.currentUserRole) return this.currentUserRole;

    return (this.currentUserRole = this.localStoreService.getItem(this.APP_ROLE));
  }

  clearUserRole() {
    this.currentUserRole = "";
  }

  retrieveUserRole(callback?: () => void) {
    console.log("retrieving user role");
    this.employeeService.apiEmployeeEmployeeGet$Json().subscribe((x) => {
      console.log("retrieved user role", x);
      this.currentUserRole = x.data?.dlmAccessLevel;
      this.localStoreService.setItem(this.APP_ROLE, this.currentUserRole);
      this.setUser(x.data);
      if (callback) callback();
    });
  }

  isRole(role: Roles) {
    var currentRole = this.getCurrentUserRole();
    return parseInt(currentRole) == role;
  }

  setCurrentUserRoleBackup(employee: EmployeeResponseDlmBaseResponse) {
    this.currentUserRole = employee.data?.dlmAccessLevel;
    this.setUser(employee.data);
    this.localStoreService.setItem(this.APP_ROLE, this.currentUserRole);
  }

  //appAuth copy to avoid circular dep:
  setUser(employee: EmployeeResponse) {
      if(!employee) {
        this.localStoreService.setItem(this.APP_USER, null);
        return;
      }
      
      var user = <any>{
        id: employee.id,
        displayName: `${employee.firstName} ${employee.lastName}`,
        role: employee.dlmAccessLevel,
        firstName: employee.firstName,
        lastName: employee.lastName,
        teamRole: employee.teamRole,
        reportsToUserId: employee.reportsToUserId,
      };
      
      this.localStoreService.setItem(this.APP_USER, user);
    }
}
